import { render, staticRenderFns } from "./ArchDetail.vue?vue&type=template&id=b698178e&scoped=true&"
import script from "./ArchDetail.vue?vue&type=script&lang=js&"
export * from "./ArchDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArchDetail.vue?vue&type=style&index=0&id=b698178e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b698178e",
  null
  
)

export default component.exports